<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('profile.material.name')"
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.comment"
            :error-messages="commentErrors"
            :label="$t('profile.material.comment')"
            @input="$v.item.comment.$touch()"
            @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="mediumSelectItems"
            v-model="item.medium"
            :items="mediumSelectItems"
            :error-messages="mediumErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.material.medium')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="feedSpecSelectItems"
            v-model="item.feedSpec"
            :items="feedSpecSelectItems"
            :error-messages="feedSpecErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.material.feedspec')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="typeSelectItems"
            v-model="item.type"
            :items="typeSelectItems"
            :error-messages="typeErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.material.type')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="colorSelectItems"
            v-model="item.color"
            :items="colorSelectItems"
            :error-messages="colorErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.material.color')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="manufacturerSelectItems"
            v-model="item.manufacturer"
            :items="manufacturerSelectItems"
            :error-messages="manufacturerErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.material.manufacturer')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="stateSelectItems"
            v-model="item.state"
            :items="stateSelectItems"
            :error-messages="stateErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.material.state')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <strong class="ml-4" >{{ $t('global.archive') }}:</strong>
          <v-switch
                v-model="item.archive"
                :error-messages="archiveErrors"
              ></v-switch>
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'MaterialForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.mediumGetSelectItems();
      this.feedSpecGetSelectItems();
      this.typeGetSelectItems();
      this.colorGetSelectItems();
      this.manufacturerGetSelectItems();
      this.stateGetSelectItems();
  },
  data() {
    return {
        name: null,
        comment: null,
        medium: null,
        feedSpec: null,
        type: null,
        color: null,
        manufacturer: null,
        state: null,
        archive: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_materialmedium ||
         this.isLoading_materialfeedspec ||
         this.isLoading_materialtype ||
         this.isLoading_materialcolor ||
         this.isLoading_materialmanufacturer ||
         this.isLoading_materialstate 
       );
    },
      ...mapFields('materialmedium', {
        mediumSelectItems: 'selectItems',
        isLoading_materialmedium : 'isLoading'
      }),
      ...mapFields('materialfeedspec', {
        feedSpecSelectItems: 'selectItems',
        isLoading_materialfeedspec : 'isLoading'
      }),
      ...mapFields('materialtype', {
        typeSelectItems: 'selectItems',
        isLoading_materialtype : 'isLoading'
      }),
      ...mapFields('materialcolor', {
        colorSelectItems: 'selectItems',
        isLoading_materialcolor : 'isLoading'
      }),
      ...mapFields('materialmanufacturer', {
        manufacturerSelectItems: 'selectItems',
        isLoading_materialmanufacturer : 'isLoading'
      }),
      ...mapFields('materialstate', {
        stateSelectItems: 'selectItems',
        isLoading_materialstate : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);


      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);


      return errors;
    },
    mediumErrors() {
      const errors = [];

      if (!this.$v.item.medium.$dirty) return errors;

      has(this.violations, 'medium') && errors.push(this.violations.medium);


      return errors;
    },
    feedSpecErrors() {
      const errors = [];

      if (!this.$v.item.feedSpec.$dirty) return errors;

      has(this.violations, 'feedSpec') && errors.push(this.violations.feedSpec);


      return errors;
    },
    typeErrors() {
      const errors = [];

      if (!this.$v.item.type.$dirty) return errors;

      has(this.violations, 'type') && errors.push(this.violations.type);


      return errors;
    },
    colorErrors() {
      const errors = [];

      if (!this.$v.item.color.$dirty) return errors;

      has(this.violations, 'color') && errors.push(this.violations.color);


      return errors;
    },
    manufacturerErrors() {
      const errors = [];

      if (!this.$v.item.manufacturer.$dirty) return errors;

      has(this.violations, 'manufacturer') && errors.push(this.violations.manufacturer);


      return errors;
    },
    stateErrors() {
      const errors = [];

      if (!this.$v.item.state.$dirty) return errors;

      has(this.violations, 'state') && errors.push(this.violations.state);


      return errors;
    },
    archiveErrors() {
      const errors = [];
      if (!this.$v.item.archive.$dirty) return errors;
      has(this.violations, 'archive') && errors.push(this.violations.archive);
      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        mediumGetSelectItems: 'materialmedium/fetchSelectItems'
      }),
      ...mapActions({
        feedSpecGetSelectItems: 'materialfeedspec/fetchSelectItems'
      }),
      ...mapActions({
        typeGetSelectItems: 'materialtype/fetchSelectItems'
      }),
      ...mapActions({
        colorGetSelectItems: 'materialcolor/fetchSelectItems'
      }),
      ...mapActions({
        manufacturerGetSelectItems: 'materialmanufacturer/fetchSelectItems'
      }),
      ...mapActions({
        stateGetSelectItems: 'materialstate/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      name: {
      },
      comment: {
      },
      medium: {
      },
      feedSpec: {
      },
      type: {
      },
      color: {
      },
      manufacturer: {
      },
      state: {
      },
      archive: {
      },
    }
  }
};
</script>
